import { render, staticRenderFns } from "./AboutYjj.vue?vue&type=template&id=6b1b6192&scoped=true&"
import script from "./AboutYjj.vue?vue&type=script&lang=js&"
export * from "./AboutYjj.vue?vue&type=script&lang=js&"
import style0 from "./AboutYjj.vue?vue&type=style&index=0&id=6b1b6192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b6192",
  null
  
)

export default component.exports